import { Trans } from 'react-i18next';
import * as S from './PoolModalHeader.styles';
import { IPoolParametersModalProps } from './PoolParametersModal';

function PoolModalHeader({ closeModal }: Pick<IPoolParametersModalProps, 'closeModal'>) {
    return (
        <S.ModalHeaderBar>
            <S.Title><Trans>POOL.MODAL_TITLE</Trans></S.Title>
            <S.CloseButton onClick={closeModal}>
                <S.CloseIcon size={20} />
            </S.CloseButton>
        </S.ModalHeaderBar>
    );
}

export default PoolModalHeader;
